import { ArrowLeftIcon2, ArrowRightIcon3 } from "assets/icons";
import ReviewCard from "components/ReviewCard";
import { Link } from "react-router-dom";

function Reviews({ reviews = [] }) {
  // const reviews = [
  //   {
  //     name: "Omar Siphron",
  //     dp: "/images/user-1.jpeg",
  //     rating: "5.0 Amazing",
  //     description:
  //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  //   },
  //   {
  //     name: "Cristofer Ekstrom Bothman",
  //     dp: "/images/user-2.jpeg",
  //     rating: "5.0 Amazing",
  //     description:
  //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  //   },
  //   {
  //     name: "Kaiya Lubin",
  //     dp: "/images/user-3.jpeg",
  //     rating: "5.0 Amazing",
  //     description:
  //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  //   },
  //   {
  //     name: "Erin Septimus",
  //     dp: "/images/user-4.jpeg",
  //     rating: "5.0 Amazing",
  //     description:
  //       "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  //   },
  // ];

  if (!reviews.length) {
    return null;
  }

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex items-center mb-3 md:mb-6">
        <div className="flex-1 text-base md:text-lg text-[#112211] font-semibold">
          Reviews
        </div>
        <Link className="text-[12px] font-semibold text-primary-700">
          See all reviews
        </Link>
      </div>
      <div className="flex items-center gap-4 mb-6">
        <div className="text-2xl md:text-[32px] md:leading-10 text-primary-700 font-semibold">
          8.6
        </div>
        <div className="flex flex-col">
          <div className="text-sm md:text-lg text-primary-700 font-semibold mb-0.5">
            Excellent
          </div>
          <div className="text-[12px] md:text-base font-medium text-[#858585]">
            617 Reviews
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col">
        {reviews.map((item, index) => (
          <ReviewCard key={index} data={item} />
        ))}
      </div>

      <div className="flex items-center justify-center gap-5 border-t-[0.5px] border-solid border-[#112211]/25 py-6">
        <button className="text-black h-4 w-4">
          <ArrowLeftIcon2 />
        </button>
        <div className="text-sm text-[#112211]">1 of 40</div>
        <button className="text-black h-4 w-4">
          <ArrowRightIcon3 />
        </button>
      </div>
    </div>
  );
}

export default Reviews;
